/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.headerModule')
  .controller('MobileHeaderTabsController', ['$scope', '$rootScope', '_', MobileHeaderTabsController]);

/**
 * Controller for our mobile header tabs.
 */
function MobileHeaderTabsController($scope, $rootScope, _) {
  this.devToolsEnabled = process.env.DEVTOOLS_ENABLED;
  this.bootstrapEnabled = process.env.BOOTSTRAP_ENABLED;

  this.setActiveTab = function setActiveTab(tab) {
    $scope.activeTab[tab] = true;
  };

  $scope.$watch('activeTab', (newVal) => {
    const tab = _.findKey(newVal, (keyTrue) => keyTrue);

    if (typeof tab !== 'undefined') {
      $rootScope.$emit('headerTabSelected', tab);
    }
  }, true);
}
